import { ProductPayload, UpdateProductPayload } from "../constants/types";
import { api } from "./api";

export const createProduct = async (
  payload: ProductPayload,
  endpoint: string
) => {
  try {
    const response = await api.post(endpoint, payload);
    return response.data;
  } catch (error) {
    console.error("Unexpected error:", error);
    throw new Error("Failed to create product.");
  }
};

export const updateProduct = async (
  payload: UpdateProductPayload,
  endpoint: string,
  id: string
) => {
  try {
    const url = endpoint + id;

    const response = await api.put(url, payload);
    return response.data;
  } catch (error) {
    console.error("Unexpected error:", error);
    throw new Error("Failed to update product.");
  }
};
